<template>
  <div class="productService">
    <div class="cont">
      <div
        class="serviceItem wow bounceInUp"
        data-wow-duration="3s"
        :data-wow-delay="index * 0.5 + 's'"
        v-for="(item, index) in serviceList"
        :key="item.id"
      >
        <i :class="['s_icon', 'icon_' + item.icon]"></i>
        <div class="s_title">{{ item.title }}</div>
        <div class="buttonLearnMore" @click="OnLink(item.url)">了解详情</div>
        <!-- <a  target="_blank" :href="item.url" class="buttonLearnMore">
          了解详情
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "productService",
  data() {
    return {
      serviceList: [
        {
          id: 1,
          key: "zhuanxiangtongji",
          icon: "statistics",
          title: "职称评审",
          url: "/professional",
        },
        {
          id: 2,
          key: "sheqingminyi",
          icon: "investigation",
          title: "职业技能",
          url: "/professional?key=SkillBoost",
        },
        {
          id: 3,
          key: "tongjibaobiao",
          icon: "report",
          title: "安全生产",
          url: "/committee",
        },
        {
          id: 5,
          key: "chuangyejiuye",
          icon: "Entrepreneurship",
          title: "创业就业",
          url: "/memberInfo",
        },
        {
          id: 4,
          key: "jishuzixun",
          icon: "consult",
          title: "线上学习",
          url: "https://hg.gzcots.com/",
          // url: "http://jxedunew.xnfedu.com/Student/login.aspx",
        },
      ],
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods:{
    OnLink(url){
        if (url.indexOf('https://') === 0 || url.indexOf('http://') === 0) {
          window.open(url)
        } else {
          this.$router.push({
            path: url,
          });
        }
    }
  }
};
</script>

<style lang="scss" scoped>
$themeColor: #003b99;
.productService {
  width: 100%;
  height: 320px;
  min-width: 1180px;
  overflow: hidden;
  position: relative;
  margin: -80px 0 0 0;
  .cont {
    display: flex;
    justify-content: space-between;
    width: 1180px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 6;
    .serviceItem {
      padding: 32px 30px 0;
      box-sizing: border-box;
      width: 220px;
      height: 254px;
      background-color: #ffffff;
      box-shadow: 0px 5px 9.4px 0.6px rgba(22, 22, 22, 0.05);
      -webkit-transition: all 0.2s ease-out;
      transition: all 0.2s ease-out;
      &:hover {
        -webkit-transform: translateY(-3px);
        -ms-transform: translateY(-3px);
        transform: translateY(-3px);
        -webkit-box-shadow: 0 0 10px #999;
        box-shadow: 0 0 10px #999;
      }
      .s_icon {
        display: block;
        width: 72px;
        height: 72px;
        margin: 0 auto;
        &.icon_statistics {
          background: url("../../assets/img/index/icon_service_1.png") center
            no-repeat;
          background-size: contain;
        }
        &.icon_investigation {
          background: url("../../assets/img/index/icon_service_2.png") center
            no-repeat;
          background-size: contain;
        }
        &.icon_report {
          background: url("../../assets/img/index/icon_service_3.png") center
            no-repeat;
          background-size: contain;
        }
        &.icon_consult {
          background: url("../../assets/img/index/icon_service_4.png") center
            no-repeat;
          background-size: contain;
        }
        &.icon_Entrepreneurship {
          background: url("../../assets/img/index/icon_service_5.png") center
            no-repeat;
          background-size: contain;
        }
      }
      .s_title {
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        padding: 10px 0 40px 0;
        text-align: center;
      }
      .buttonLearnMore {
      cursor: pointer;
        display: block;
        width: 106px;
        height: 30px;
        line-height: 30px;
        background-color: $themeColor;
        border-radius: 5px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        margin: 0 auto;
      }
    }
  }
}
</style>
